(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["at-product-support"] && !Shopify.designMode) return;
  try {
    ['vh-support-videos', 'vh-support-reviews'].forEach(elementName => {
  if (!customElements.get(elementName)) customElements.define(elementName, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-support-track]');
      this.slides = [...this.querySelectorAll('[data-support-slide]')];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-support-prev]');
      this.next = this.querySelector('[data-support-next]');
      this.status = this.querySelector('[data-support-status]');
      this.dots = [...this.querySelectorAll('[data-support-index]')];
      this.index = Math.min(this.index || 0, this.slides.length - 1);
      this.targetIndex = null;
      this.querySelector('[data-support-controls]')?.removeAttribute('hidden');
      this.previous?.addEventListener('click', () => this.go(this.index - 1), options);
      this.next?.addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.supportIndex)), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      const releaseTarget = () => { this.targetIndex = null; };
      this.track.addEventListener('pointerdown', releaseTarget, options);
      this.track.addEventListener('wheel', releaseTarget, { ...options, passive: true });
      if (elementName === 'vh-support-reviews') {
        this.track.setAttribute?.('data-support-enhanced', 'true');
        this.track.addEventListener('pointerdown', event => this.startSwipe(event), options);
        this.track.addEventListener('pointermove', event => this.moveSwipe(event), options);
        this.track.addEventListener('pointerup', event => this.finishSwipe(event), options);
        this.track.addEventListener('pointercancel', event => this.finishSwipe(event, true), options);
      }
      this.track.addEventListener('scroll', () => {
        if (this.touchGesture) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.targetIndex === null) {
            this.index = this.observedIndex();
            this.update();
          }
        });
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncScroll(), 150);
      }, options);
      this.track.addEventListener('scrollend', () => this.syncScroll(), options);
      this.addEventListener('play', event => {
        this.slides.forEach(slide => slide.querySelectorAll('video').forEach(video => {
          if (video !== event.target) video.pause();
        }));
      }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAll();
      }, options);
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
        this.resizeObserver.observe(this.track);
      }
      if (typeof IntersectionObserver !== 'undefined') {
        this.viewportObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => !entry.isIntersecting)) this.pauseAll();
        }, { threshold: 0 });
        this.viewportObserver.observe(this);
        this.slideObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
              entry.target.querySelectorAll('video').forEach(video => video.pause());
            }
          });
        }, { root: this.track, threshold: [0, 0.5] });
        this.slides.forEach(slide => this.slideObserver.observe(slide));
      }
      this.go(this.index, true);
    }
    observedIndex() {
      return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
    }
    startSwipe(event) {
      if (event.isPrimary === false || !['touch', 'pen'].includes(event.pointerType) || !Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return;
      this.touchGesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, index: this.index };
      this.track.setAttribute?.('data-support-dragging', 'true');
      this.track.setPointerCapture?.(event.pointerId);
    }
    moveSwipe(event) {
      const gesture = this.touchGesture;
      if (!gesture || event.pointerId !== gesture.pointerId) return;
      const distance = gesture.x - event.clientX;
      if (Math.abs(distance) < 8 || Math.abs(distance) <= Math.abs(gesture.y - event.clientY)) return;
      const width = this.track.clientWidth;
      const left = gesture.index * width + Math.max(-width, Math.min(width, distance));
      this.track.scrollTo({ left: Math.max(0, Math.min((this.slides.length - 1) * width, left)), behavior: 'auto' });
    }
    finishSwipe(event, canceled = false) {
      const gesture = this.touchGesture;
      if (!gesture || event.pointerId !== gesture.pointerId) return;
      this.touchGesture = null;
      this.track.removeAttribute('data-support-dragging');
      if (this.track.hasPointerCapture?.(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
      const distance = gesture.x - event.clientX;
      const horizontal = Math.abs(distance) > Math.abs(gesture.y - event.clientY);
      const threshold = Math.max(28, this.track.clientWidth * 0.12);
      const shift = !canceled && horizontal && Math.abs(distance) >= threshold ? Math.sign(distance) : 0;
      this.go(gesture.index + shift);
    }
    syncScroll() {
      if (this.touchGesture) return;
      clearTimeout(this.scrollTimer);
      this.targetIndex = null;
      this.index = this.observedIndex();
      this.update();
    }
    go(index, instant = false) {
      clearTimeout(this.scrollTimer);
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      const immediate = instant || matchMedia('(prefers-reduced-motion: reduce)').matches;
      const left = this.index * this.track.clientWidth;
      this.targetIndex = immediate || Math.abs(this.track.scrollLeft - left) < 1 ? null : this.index;
      this.track.scrollTo({ left, behavior: immediate ? 'auto' : 'smooth' });
      this.update();
    }
    update() {
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      if (this.status) this.status.textContent = this.status.dataset.statusTemplate.replace('__number__', String(this.index + 1)).replace('__count__', String(this.slides.length));
      this.dots?.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.index)));
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        if (index !== this.index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    }
    pauseAll() {
      this.slides?.forEach(slide => slide.querySelectorAll('video').forEach(video => video.pause()));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.viewportObserver?.disconnect();
      this.slideObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.scrollTimer);
      this.pauseAll();
      this.slides?.forEach(slide => { slide.inert = false; });
      this.track?.removeAttribute('data-support-enhanced');
      this.track?.removeAttribute('data-support-dragging');
      this.touchGesture = null;
      this.targetIndex = null;
      this.controller = null;
    }
  });
  });
  function vhUpdateDeliveryDates(root = document) {
    root.querySelectorAll('[data-support-delivery]').forEach(element => {
      const output = element.querySelector('[data-support-delivery-date]');
      if (!output) return;
      const days = Math.max(0, Math.min(30, Number.parseInt(element.dataset.businessDays, 10) || 0));
      const estimate = new Date();
      estimate.setHours(12, 0, 0, 0);
      let added = 0;
      while (added < days) {
        estimate.setDate(estimate.getDate() + 1);
        if (estimate.getDay() !== 0 && estimate.getDay() !== 6) added++;
      }
      const day = estimate.getDate();
      const suffix = day > 10 && day < 14 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
      const weekday = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(estimate);
      const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(estimate);
      output.textContent = `${weekday}, ${month} ${day}${suffix}`;
      output.dateTime = `${estimate.getFullYear()}-${String(estimate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => vhUpdateDeliveryDates(), { once: true });
  else vhUpdateDeliveryDates();
  document.addEventListener('shopify:section:load', event => vhUpdateDeliveryDates(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-four-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vh-action-videos')) customElements.define('vh-action-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.vh-action__track');
      this.cards = [...this.querySelectorAll('[data-action-card]')];
      this.videos = [...this.querySelectorAll('video')];
      this.navigation = this.querySelector('[data-action-navigation]');
      this.previous = this.querySelector('[data-action-prev]');
      this.next = this.querySelector('[data-action-next]');
      this.status = this.querySelector('[data-action-status]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = new Map();
      this.near = new Set();
      this.videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.controls = false;
        video.playsInline = true;
        video.loop = true;
        video.removeAttribute('controls');
        video.addEventListener('loadeddata', () => this.sync(), options);
        video.addEventListener('canplay', () => this.sync(), options);
        if (this.motion.matches) video.pause();
      });
      this.toggle = this.querySelector('[data-action-pause]');
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle.textContent = this.userPaused ? this.toggle.dataset.resumeLabel : this.toggle.dataset.pauseLabel;
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pageshow', () => this.sync(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
      this.track?.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.scrollToPosition(event.key === 'Home' ? 0 : this.maxScroll());
        else this.navigate(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.previous?.addEventListener('click', () => this.navigate(-1), options);
      this.next?.addEventListener('click', () => this.navigate(1), options);
      this.track?.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
      window.addEventListener('resize', () => this.updateNavigation(), options);
      if (typeof ResizeObserver !== 'undefined' && this.track) {
        this.resize = new ResizeObserver(() => this.updateNavigation());
        this.resize.observe(this.track);
      }
      this.updateNavigation();
      if (typeof IntersectionObserver !== 'undefined') {
        this.preloading = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this.near.add(entry.target);
            else this.near.delete(entry.target);
          });
          this.sync();
        }, { rootMargin: '200px 0px', threshold: 0 });
        this.visibility = new IntersectionObserver(entries => {
          entries.forEach(entry => this.visible.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.2));
          this.sync();
        }, { threshold: [0, 0.2] });
        this.videos.forEach(video => {
          this.preloading.observe(video);
          this.visibility.observe(video);
        });
      } else {
        const measure = () => {
          this.videos.forEach(video => {
            const rect = video.getBoundingClientRect();
            const track = this.track?.getBoundingClientRect() || rect;
            const horizontal = rect.right > Math.max(0, track.left) && rect.left < Math.min(window.innerWidth, track.right);
            this.visible.set(video, horizontal && rect.bottom > 0 && rect.top < window.innerHeight);
            if (horizontal && rect.bottom > -200 && rect.top < window.innerHeight + 200) this.near.add(video);
            else this.near.delete(video);
          });
          this.sync();
        };
        window.addEventListener('scroll', measure, { ...options, passive: true });
        window.addEventListener('resize', measure, options);
        this.track?.addEventListener('scroll', measure, { ...options, passive: true });
        measure();
      }
    }
    maxScroll() {
      return Math.max(0, (this.track?.scrollWidth || 0) - (this.track?.clientWidth || 0));
    }
    measurements() {
      const first = this.cards[0];
      const stride = this.cards.length > 1 ? this.cards[1].offsetLeft - first.offsetLeft : first?.clientWidth || 1;
      const gap = Math.max(0, stride - (first?.clientWidth || 0));
      const pageSize = Math.max(1, Math.floor(((this.track?.clientWidth || 0) + gap + 2) / Math.max(1, stride)));
      return { stride: Math.max(1, stride), pageSize };
    }
    navigate(direction) {
      if (!this.track || !this.cards.length) return;
      const { stride, pageSize } = this.measurements();
      const current = Math.round(Math.max(0, this.track.scrollLeft) / stride);
      const target = Math.max(0, Math.min(this.cards.length - pageSize, current + direction * pageSize));
      this.scrollToPosition(Math.min(this.maxScroll(), target * stride));
    }
    scrollToPosition(left) {
      this.track?.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' });
      this.updateNavigation();
    }
    updateNavigation() {
      if (!this.navigation || !this.track) return;
      const maximum = this.maxScroll();
      const position = Math.max(0, Math.min(maximum, this.track.scrollLeft));
      const overflow = maximum > 2;
      this.navigation.hidden = !overflow;
      if (this.previous) this.previous.disabled = !overflow || position <= 2;
      if (this.next) this.next.disabled = !overflow || position >= maximum - 2;
      if (!this.status || !this.cards.length) return;
      const { stride, pageSize } = this.measurements();
      const start = Math.min(this.cards.length, Math.round(position / stride) + 1);
      const end = Math.min(this.cards.length, start + pageSize - 1);
      const label = this.status.dataset.statusTemplate.replace('__START__', String(start)).replace('__END__', String(end)).replace('__COUNT__', String(this.cards.length));
      if (this.status.textContent !== label) this.status.textContent = label;
    }
    sync() {
      this.videos?.forEach(video => {
        if (this.near.has(video) && !document.hidden) {
          if (video.dataset.poster) {
            video.poster = video.dataset.poster;
            delete video.dataset.poster;
          }
          if (!this.motion.matches && !this.userPaused && !video.dataset.loaded) {
            video.dataset.loaded = 'true';
            if (video.dataset.src) video.src = video.dataset.src;
            video.querySelectorAll('source[data-src]').forEach(source => {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
            });
            video.preload = 'auto';
            video.load();
          }
        }
        if (document.hidden || this.motion.matches || this.userPaused || !this.visible.get(video)) video.pause();
        else if (video.dataset.loaded && video.paused) video.play()?.catch(() => {});
      });
    }
    disconnectedCallback() {
      this.videos?.forEach(video => video.pause());
      this.controller?.abort();
      this.visibility?.disconnect();
      this.preloading?.disconnect();
      this.resize?.disconnect();
      this.controller = null;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-product-support"] && !Shopify.designMode) return;
  try {
    ['vh-support-videos', 'vh-support-reviews'].forEach(elementName => {
  if (!customElements.get(elementName)) customElements.define(elementName, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-support-track]');
      this.slides = [...this.querySelectorAll('[data-support-slide]')];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-support-prev]');
      this.next = this.querySelector('[data-support-next]');
      this.status = this.querySelector('[data-support-status]');
      this.dots = [...this.querySelectorAll('[data-support-index]')];
      this.index = Math.min(this.index || 0, this.slides.length - 1);
      this.targetIndex = null;
      this.querySelector('[data-support-controls]')?.removeAttribute('hidden');
      this.previous?.addEventListener('click', () => this.go(this.index - 1), options);
      this.next?.addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.supportIndex)), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      const releaseTarget = () => { this.targetIndex = null; };
      this.track.addEventListener('pointerdown', releaseTarget, options);
      this.track.addEventListener('wheel', releaseTarget, { ...options, passive: true });
      if (elementName === 'vh-support-reviews') {
        this.track.setAttribute?.('data-support-enhanced', 'true');
        this.track.addEventListener('pointerdown', event => this.startSwipe(event), options);
        this.track.addEventListener('pointermove', event => this.moveSwipe(event), options);
        this.track.addEventListener('pointerup', event => this.finishSwipe(event), options);
        this.track.addEventListener('pointercancel', event => this.finishSwipe(event, true), options);
      }
      this.track.addEventListener('scroll', () => {
        if (this.touchGesture) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.targetIndex === null) {
            this.index = this.observedIndex();
            this.update();
          }
        });
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncScroll(), 150);
      }, options);
      this.track.addEventListener('scrollend', () => this.syncScroll(), options);
      this.addEventListener('play', event => {
        this.slides.forEach(slide => slide.querySelectorAll('video').forEach(video => {
          if (video !== event.target) video.pause();
        }));
      }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAll();
      }, options);
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
        this.resizeObserver.observe(this.track);
      }
      if (typeof IntersectionObserver !== 'undefined') {
        this.viewportObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => !entry.isIntersecting)) this.pauseAll();
        }, { threshold: 0 });
        this.viewportObserver.observe(this);
        this.slideObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
              entry.target.querySelectorAll('video').forEach(video => video.pause());
            }
          });
        }, { root: this.track, threshold: [0, 0.5] });
        this.slides.forEach(slide => this.slideObserver.observe(slide));
      }
      this.go(this.index, true);
    }
    observedIndex() {
      return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
    }
    startSwipe(event) {
      if (event.isPrimary === false || !['touch', 'pen'].includes(event.pointerType) || !Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return;
      this.touchGesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, index: this.index };
      this.track.setAttribute?.('data-support-dragging', 'true');
      this.track.setPointerCapture?.(event.pointerId);
    }
    moveSwipe(event) {
      const gesture = this.touchGesture;
      if (!gesture || event.pointerId !== gesture.pointerId) return;
      const distance = gesture.x - event.clientX;
      if (Math.abs(distance) < 8 || Math.abs(distance) <= Math.abs(gesture.y - event.clientY)) return;
      const width = this.track.clientWidth;
      const left = gesture.index * width + Math.max(-width, Math.min(width, distance));
      this.track.scrollTo({ left: Math.max(0, Math.min((this.slides.length - 1) * width, left)), behavior: 'auto' });
    }
    finishSwipe(event, canceled = false) {
      const gesture = this.touchGesture;
      if (!gesture || event.pointerId !== gesture.pointerId) return;
      this.touchGesture = null;
      this.track.removeAttribute('data-support-dragging');
      if (this.track.hasPointerCapture?.(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
      const distance = gesture.x - event.clientX;
      const horizontal = Math.abs(distance) > Math.abs(gesture.y - event.clientY);
      const threshold = Math.max(28, this.track.clientWidth * 0.12);
      const shift = !canceled && horizontal && Math.abs(distance) >= threshold ? Math.sign(distance) : 0;
      this.go(gesture.index + shift);
    }
    syncScroll() {
      if (this.touchGesture) return;
      clearTimeout(this.scrollTimer);
      this.targetIndex = null;
      this.index = this.observedIndex();
      this.update();
    }
    go(index, instant = false) {
      clearTimeout(this.scrollTimer);
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      const immediate = instant || matchMedia('(prefers-reduced-motion: reduce)').matches;
      const left = this.index * this.track.clientWidth;
      this.targetIndex = immediate || Math.abs(this.track.scrollLeft - left) < 1 ? null : this.index;
      this.track.scrollTo({ left, behavior: immediate ? 'auto' : 'smooth' });
      this.update();
    }
    update() {
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      if (this.status) this.status.textContent = this.status.dataset.statusTemplate.replace('__number__', String(this.index + 1)).replace('__count__', String(this.slides.length));
      this.dots?.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.index)));
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        if (index !== this.index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    }
    pauseAll() {
      this.slides?.forEach(slide => slide.querySelectorAll('video').forEach(video => video.pause()));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.viewportObserver?.disconnect();
      this.slideObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.scrollTimer);
      this.pauseAll();
      this.slides?.forEach(slide => { slide.inert = false; });
      this.track?.removeAttribute('data-support-enhanced');
      this.track?.removeAttribute('data-support-dragging');
      this.touchGesture = null;
      this.targetIndex = null;
      this.controller = null;
    }
  });
  });
  function vhUpdateDeliveryDates(root = document) {
    root.querySelectorAll('[data-support-delivery]').forEach(element => {
      const output = element.querySelector('[data-support-delivery-date]');
      if (!output) return;
      const days = Math.max(0, Math.min(30, Number.parseInt(element.dataset.businessDays, 10) || 0));
      const estimate = new Date();
      estimate.setHours(12, 0, 0, 0);
      let added = 0;
      while (added < days) {
        estimate.setDate(estimate.getDate() + 1);
        if (estimate.getDay() !== 0 && estimate.getDay() !== 6) added++;
      }
      const day = estimate.getDate();
      const suffix = day > 10 && day < 14 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
      const weekday = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(estimate);
      const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(estimate);
      output.textContent = `${weekday}, ${month} ${day}${suffix}`;
      output.dateTime = `${estimate.getFullYear()}-${String(estimate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => vhUpdateDeliveryDates(), { once: true });
  else vhUpdateDeliveryDates();
  document.addEventListener('shopify:section:load', event => vhUpdateDeliveryDates(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-reference-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vh-reference-video')) customElements.define('vh-reference-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const video = this.querySelector('video');
      if (!video) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const playButton = this.querySelector('[data-reference-play]');
      const syncPlayButton = () => {
        if (playButton) playButton.hidden = !video.paused && !video.ended;
      };
      playButton?.addEventListener('click', async () => {
        try {
          await video.play();
        } catch {
          syncPlayButton();
        }
      }, options);
      video.addEventListener('playing', () => {
        if (playButton) playButton.hidden = true;
      }, options);
      video.addEventListener('pause', syncPlayButton, options);
      video.addEventListener('ended', syncPlayButton, options);
      syncPlayButton();
      const fitVideo = () => {
        if (video.videoWidth > 0 && video.videoHeight > 0) {
          this.style.setProperty('--vh-reference-video-ratio', String(video.videoWidth / video.videoHeight));
        }
      };
      video.addEventListener('loadedmetadata', fitVideo, options);
      video.addEventListener('resize', fitVideo, options);
      if (video.readyState > 0) fitVideo();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vh-tool-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vh-tool-search'))customElements.define('vh-tool-search',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.details=this.querySelector('details');this.input=this.querySelector('[data-search-input]');this.results=[...this.querySelectorAll('[data-search-item]')];
      if(!this.details||!this.input)return;
      this.setAttribute('data-enhanced','');
      this.input.addEventListener('input',()=>this.filter(),options);
      this.details.addEventListener('toggle',()=>{if(this.details.open){document.querySelectorAll('.vh-header__mobile-menu[open]').forEach(menu=>menu.open=false);this.input.focus({preventScroll:true})}},options);
      this.querySelector('[data-search-close]').addEventListener('click',()=>this.close(true),options);
      document.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.details.open){event.preventDefault();this.close(true)}},options);
      document.addEventListener('click',event=>{if(this.details.open&&!this.contains(event.target))this.close(false)},options);
      this.filter();
    }
    normalize(value){return value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase()}
    filter(){const terms=this.normalize(this.input.value).trim().split(/\s+/).filter(Boolean);let count=0;this.results.forEach(item=>{item.hidden=!terms.every(term=>this.normalize(item.dataset.searchTitle).includes(term));if(!item.hidden)count++});this.querySelector('[data-search-empty]').hidden=count>0;this.querySelector('[data-search-status]').textContent=this.dataset.countLabel.replace('__count__',String(count))}
    close(restore){this.details.open=false;if(restore)this.querySelector('summary').focus({preventScroll:true})}
    disconnectedCallback(){this.controller?.abort();this.controller=null}
  });
  } catch(e) { console.error(e); }
})();

})();
